export enum ClaimStatus {
    inProgress = 'IN_PROGRESS',
    archived = 'ARCHIVED',
}

export enum ContractStatus {
    new = 'NEW',
    signed = 'SIGNED',
    canceled = 'CANCELED',
}

export enum PartyStatus {
    active = 'ACTIVE',
    inactive = 'INACTIVE',
}

export enum ClaimStatusColor {
    NEW = 'info',
    IN_PROGRESS = 'warning',
    DONE = 'success',
    CANCELED = 'danger',
    ARCHIVED = 'secondary',
}

export enum ContractStatusColor {
    NEW = 'info',
    SIGNED = 'success',
    CANCELED = 'danger',
}

export enum PartyStatusColor {
    ACTIVE = 'success',
    INACTIVE = 'danger',
}
